<h3 data-cy="add-bank-account-title-text">
  <ion-icon
    *ngIf="isMobile && currentAutopayStep > autopaySteps.stepOne"
    (click)="changeAutopayStep(currentAutopayStep - 1)"
    data-cy="autopay-chevron-back"
    name="chevron-back-outline"
  ></ion-icon>
  <ng-container
    [ngSwitch]="
      (isMobile || currentAutopayStep === autopaySteps.confirmAutopayDetails) &&
      currentAutopayStep
    "
  >
    <ng-container *ngSwitchCase="autopaySteps.stepTwo">{{
      'i18n.header.selectCustomer' | translate
    }}</ng-container>
    <ng-container *ngSwitchCase="autopaySteps.stepThree">{{
      'i18n.payments.addBankAccountModal.effectiveDate' | translate
    }}</ng-container>
    <ng-container *ngSwitchCase="autopaySteps.confirmAutopayDetails">{{
      'i18n.payments.addBankAccountModal.confirmAutopayDetails' | translate
    }}</ng-container>
    <ng-container *ngSwitchDefault>{{
      'i18n.payments.addBankAccountModal.setupAutopay' | translate
    }}</ng-container>
  </ng-container>

  <span
    data-cy="current-step-title"
    *ngIf="isMobile && currentAutopayStep < autopaySteps.confirmAutopayDetails"
    >&nbsp;{{
      'i18n.payments.addBankAccountModal.autopayStep'
        | translate: { step: currentAutopayStep }
    }}</span
  >
</h3>

<ion-row class="no-padding">
  <ion-col
    class="steps-column"
    *ngIf="
      !isMobile && currentAutopayStep !== autopaySteps.confirmAutopayDetails
    "
  >
    <app-autopay-steps
      [currentAutopayStep]="currentAutopayStep"
      [isStepOneCompleted]="
        selectedSegment === toggleOptions.existingAccount
          ? !!selectedBankAccount
          : addBankAccountForm.valid
      "
      [isStepTwoCompleted]="selectedCustomers.length > 0"
      [isStepThreeCompleted]="!!effectiveDate"
      (changeAutopayStepEmit)="changeAutopayStep($event)"
    >
    </app-autopay-steps>
  </ion-col>

  <ion-col
    class="form-column"
    *ngIf="currentAutopayStep === autopaySteps.stepOne"
  >
    <app-segments-bank-account
      [isSettingUpAutopay]="true"
      [selectedSegment]="selectedSegment"
      [selectedBankAccount]="selectedBankAccount"
      [addBankAccountForm]="addBankAccountForm"
      [bankAccounts]="bankAccounts"
      [isDesktop]="isDesktop"
      [canModifyForm]="canModifyForm"
      [selectedCustomers]="selectedCustomers"
      [isBankRoutingValidationOn]="isBankRoutingValidationOn"
      (isLoadingEmit)="isFormLoading($event)"
      (selectBankAccountEmitter)="selectBankAccount($event)"
      (setSelectedSegmentEmit)="setSelectedSegment($event)"
      (submitFormEmitter)="validateFormForAutopay()"
    ></app-segments-bank-account>
  </ion-col>

  <ion-col
    class="customer-column"
    *ngIf="currentAutopayStep === autopaySteps.stepTwo"
  >
    <app-customer-selection-payments-touch
      [vm$]="vmWithCustomers$"
      [searchText$]="searchText$"
      [title]="'i18n.payments.addBankAccountModal.customers' | translate"
      [isPresentedInFilterModal]="false"
      [selectedCustomers]="selectedCustomers"
      (customersToFilterSelected)="selectCustomers($event)"
    ></app-customer-selection-payments-touch>
  </ion-col>

  <ion-col
    class="date-column"
    *ngIf="currentAutopayStep === autopaySteps.stepThree"
  >
    <app-autopay-effective-date
      (selectEffectiveDateEmitter)="selectEffectiveDate($event)"
    ></app-autopay-effective-date>
  </ion-col>

  <ion-col *ngIf="currentAutopayStep === autopaySteps.confirmAutopayDetails">
    <app-confirm-autopay-details
      [autopayDetails]="autopayDetails"
      [isDesktop]="isDesktop"
      (setConfirmationValidEmit)="setConfirmationValid($event)"
    ></app-confirm-autopay-details>
  </ion-col>
</ion-row>
